import {actions} from 'forms/rrf';
import api from '../irelandApi';
import {
  GET_EMAIL_LOGS_PENDING,
  GET_EMAIL_LOGS_FULFILLED,
  GET_EMAIL_LOGS_REJECTED,
  GET_SMS_LOGS_PENDING,
  GET_SMS_LOGS_FULFILLED,
  GET_SMS_LOGS_REJECTED,
  GET_EMAIL_BODY_FULFILLED,
  GET_EMAIL_BODY_PENDING,
  GET_EMAIL_BODY_REJECTED,
  GET_EMAIL_LOG_PENDING,
  GET_EMAIL_LOG_FULFILLED,
  GET_EMAIL_LOG_REJECTED,
  GET_SMS_LOG_FULFILLED,
  GET_SMS_LOG_REJECTED,
  GET_SMS_LOG_PENDING,
  PATCH_EMAIL_LOG_FULFILLED,
  PATCH_EMAIL_LOG_PENDING,
  PATCH_EMAIL_LOG_REJECTED
} from '../reducers/logReducer';

export const getEmailLogs = (filter = '', page = 1) => (dispatch) => {
  dispatch({type: GET_EMAIL_LOGS_PENDING});

  return api.get('/api/admin/email_logs', {
    params: {
      q: filter,
      page
    }
  })
    .then((response) => {
      dispatch({type: GET_EMAIL_LOGS_FULFILLED, payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: GET_EMAIL_LOGS_REJECTED, payLoad: error.data});
    });
};

export const getEmailLog = id => (dispatch) => {
  dispatch({type: GET_EMAIL_LOG_PENDING});
  return api.get(`/api/admin/email_logs/${id}/edit`)
    .then((response) => {
      dispatch({type: GET_EMAIL_LOG_FULFILLED, payLoad: response.data});
      dispatch(actions.load('deep.edit_email_notifications', response.data.data.attributes));
    })
    .catch((error) => {
      dispatch({type: GET_EMAIL_LOG_REJECTED, payLoad: error.data});
    });
};


export const updateEmailLog = (id, payLoad, send = false) => (dispatch) => {
  dispatch({type: PATCH_EMAIL_LOG_PENDING});
  return api.patch(`/api/admin/email_logs/${id}${send ? '?send=true' : ''}`, {email_log: payLoad})
    .then(() => {
      dispatch({type: PATCH_EMAIL_LOG_FULFILLED});
    })
    .catch((error) => {
      dispatch({type: PATCH_EMAIL_LOG_REJECTED, payLoad: error.data});

      Promise.reject(error);
    });
};

export const getEmailBody = id => (dispatch) => {
  dispatch({type: GET_EMAIL_BODY_PENDING});

  return api.get(`/api/admin/email_logs/${id}`)
    .then((response) => {
      dispatch({type: GET_EMAIL_BODY_FULFILLED, payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: GET_EMAIL_BODY_REJECTED, payLoad: error.data});
    });
};


export const getSmsLogs = (filter = '', page = 1) => (dispatch) => {
  dispatch({type: GET_SMS_LOGS_PENDING});

  return api.get('/api/admin/sms_logs', {
    params: {
      q: filter,
      page
    }
  })
    .then((response) => {
      dispatch({type: GET_SMS_LOGS_FULFILLED, payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: GET_SMS_LOGS_REJECTED, payLoad: error.data});
    });
};


export const getSmsLog = id => (dispatch) => {
  dispatch({type: GET_SMS_LOG_PENDING});

  return api.get(`/api/admin/sms_logs/${id}`)

    .then((response) => {
      dispatch({type: GET_SMS_LOG_FULFILLED, payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: GET_SMS_LOG_REJECTED, payLoad: error.data});
    });
};

